export const i18nSensorsPage = {
  sections: {
    total: 'Total',
    data_health: 'Status (data health)',
    sensors_data: 'Sensors data',
  },
  components: {
    status_table: {
      headers: {
        status: 'Status',
        description: 'Description',
        label: 'Tag',
        value: 'Latest read',
        low_low_threshold: 'Lo Lo',
        low_threshold: 'Lo',
        high_threshold: 'Hi',
        high_high_threshold: 'Hi Hi',
        display_threshold: 'Display thresholds',
      },
      no_value: 'No value',
      edit: 'Edit {{tag}}',
    },
    edit_modal: {
      low_low_threshold: 'Lo Lo',
      low_threshold: 'Lo',
      high_threshold: 'Hi',
      high_high_threshold: 'Hi Hi',
      submit_btn: 'Save',
      clear_btn: 'Clear',
      details_reason: 'Reason / Justification',
    },
    tabs: {
      edit: 'Edit limits',
      history: 'History',
    },
    history: {
      headers: {
        date: 'Date / hour',
        low_low_threshold: 'Lo Lo',
        low_threshold: 'Lo',
        high_threshold: 'Hi',
        high_high_threshold: 'Hi Hi',
        reason: 'Details / reason',
        user: 'User',
      },
    },
  },
  message: {
    limit_error: {
      title: 'Ops...',
      message: 'Error updating limits. Please try again.',
    },
    limit_success: {
      title: 'Success!',
      message: 'Limits successfully updated!',
    },
    asset_error: {
      title: 'Ops..',
      message: 'Unable to load asset data. Try again on few minutes',
    },
    sensors_status_error: {
      title: 'Ops..',
      message: 'Unable to load sensors data. Try again on few minutes',
    },
    no_alarms: {
      title: 'No alarms',
    },
    alarms_error: {
      title: 'Ops..',
      message: 'Unable to load alarm data. Try again on few minutes',
    },
  },
};
